<div class="container-fluid mt-4">
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header align-items-center d-flex justify-content-between">
          <h5 class="font-medium m-0">👨‍💼 Add New Member</h5>
        </div>
        <div class="card-body">
          <div class="row align-items-end">
            <form #memberForm="ngForm" (ngSubmit)="submitForm(memberForm);memberForm.resetForm()">
              <div class="row">
                <!-- User Type -->
                <div class="col-lg-4 col-md-4 mb-2">
                  <label class="form-label m-0">User Type<span class="text-danger">*</span></label>
                  <select class="form-control" [(ngModel)]="newMember.userTypeId" id="userType" name="userType"
                    #userType="ngModel" required (change)="onUserTypeChange($event)">
                    <option value="0" disabled selected>Select User Type</option>

                    <option *ngFor="let data of userData" [value]="data.id">
                      {{ data.name }}
                    </option>
                  </select>
                  <div *ngIf="userType.invalid && userType.touched" class="text-danger">
                    User Type is required.
                  </div>
                </div>

                <!-- Name -->
                <div class="col-lg-4 col-md-4 mb-2">
                  <label class="form-label m-0">User Name<span class="text-danger">*</span></label>
                  <input type="text" class="form-control" [(ngModel)]="newMember.name" id="name" name="name"
                    #name="ngModel" placeholder="Enter Name" required minlength="4" maxlength="50"  minlength="4"
         maxlength="50"
         (keypress)="allowOnlyAlphabets($event)" />
                  <div *ngIf="name.invalid && name.touched" class="text-danger">
                    Name is required (min 4 characters).
                  </div>
                </div>

                <!-- District -->
                <div class="col-lg-4 col-md-4 mb-2">
                  <label class="form-label m-0">District<span class="text-danger">*</span></label>
                  <select class="form-control" [(ngModel)]="newMember.districtId" id="district" name="district"
                    #district="ngModel" required (change)="onDistrictChange($event)">
                    <option value="0" disabled selected>Select District</option>
                    <option *ngFor="let dist of districts" [value]="dist.id">
                      {{ dist.name }}
                    </option>
                  </select>
                  <div *ngIf="district.invalid && district.touched" class="text-danger">
                    District is required.
                  </div>
                </div>

                <!-- Circle -->
                <div class="col-lg-4 col-md-4 mb-2" *ngIf="newMember.districtId && newMember.districtId != 0">
                  <label class="form-label m-0">Circle<span class="text-danger">*</span></label>
                  <select class="form-control" [(ngModel)]="newMember.circleId" id="circle" name="circle" required
                    (change)="onCircleChange($event)">
                    <option value="0" disabled selected>Select Circle</option>
                    <option *ngFor="let circle of circlesData" [value]="circle.id">
                      {{ circle.name }}
                    </option>
                  </select>
                </div>

                <!-- Block -->
                <div class="col-lg-4 col-md-4 mb-2" *ngIf="newMember.circleId && newMember.circleId != 0">
                  <label class="form-label m-0">Block<span class="text-danger">*</span></label>
                  <select class="form-control" [(ngModel)]="newMember.blockId" id="block" name="block" required>
                    <option value="0" disabled selected>Select Block</option>
                    <option *ngFor="let block of blocksData" [value]="block.id">
                      {{ block.name }}
                    </option>
                  </select>
                </div>


                <!-- Address -->
                <div class="col-lg-4 col-md-4 mb-2">
                  <label class="form-label m-0">Address<span class="text-danger">*</span></label>
                  <input type="text" class="form-control" [(ngModel)]="newMember.address" id="address" name="address"
                    placeholder="Enter Address" required minlength="3" maxlength="200" #address="ngModel" />
                  <div *ngIf="address.invalid && address.touched" class="text-danger">
                    Address is required (min 3 characters and max 200 characters).
                  </div>
                </div>

                <!-- Designation -->
                <div class="col-lg-4 col-md-4 mb-2" *ngIf="isDesignation">
                  <label class="form-label m-0">Designation<span class="text-danger">*</span></label>
                  <select class="form-control" [(ngModel)]="newMember.designationId" id="designation" name="designation"
                    #designation="ngModel" required>
                    <option value="0" disabled selected>Select Designation</option>
                    <option *ngFor="let data of designationsData" [value]="data.id">
                      {{ data.name }}
                    </option>
                  </select>
                  <div *ngIf="designation.invalid && designation.touched" class="text-danger">
                    Designation is required.
                  </div>
                </div>

                <!-- Experience -->
                <div class="col-lg-4 col-md-4 mb-2">
                  <label class="form-label m-0">Experience <sup>(In Years)</sup><span
                      class="text-danger">*</span></label>
                  <input type="text" class="form-control" [(ngModel)]="newMember.experience" id="experience"
                    name="experience" placeholder="Enter Experience" required minlength="1" maxlength="2"
                    #experience="ngModel" />
                  <div *ngIf="experience.invalid && experience.touched" class="text-danger">
                    Experience is required (min 2 characters).
                  </div>
                </div>

                <!-- Mobile Number -->
                <div class="col-lg-4 col-md-4 mb-2" *ngIf="!editMode">
                  <label class="form-label m-0">Mobile Number<span class="text-danger">*</span></label>
                  <input type="number" class="form-control" [(ngModel)]="newMember.mobile" id="mobile" name="mobile"
                    placeholder="Enter Mobile Number" required minlength="10" #mobile="ngModel"
                    (input)="validateMobile($event)" />

                  <div *ngIf="mobile.invalid && mobile.touched" class="text-danger">
                    Mobile No is required (10 digits only).
                  </div>
                </div>

                <!-- Email -->
                <div class="col-lg-4 col-md-4 mb-2" *ngIf="!editMode">
                  <label class="form-label m-0">Email Id<span class="text-danger">*</span></label>
                  <input type="email" class="form-control" [(ngModel)]="newMember.emailId" id="email" name="email"
                    placeholder="Enter Email" required #email="ngModel" maxlength="60"
                    (input)="validateEmail($event)" />
                  <div *ngIf="email.invalid && email.touched" class="text-danger">
                    A valid email is required.
                  </div>
                  <div *ngIf="!isEmailValid && email.touched" class="text-danger">
                    Please enter a valid email address.
                  </div>
                </div>

                <!-- Password -->
                <div class="col-lg-4 col-md-4 mb-2" *ngIf="!editMode">
                  <label class="form-label m-0">Password<span class="text-danger">*</span></label>
                  <input type="password" id="password" name="password" class="form-control"
                    [(ngModel)]="newMember.password" placeholder="Enter Password" #password="ngModel" required
                    minlength="6" maxlength="15" [ngClass]="{'invalid-input': password.invalid && password.touched}" />

                  <div *ngIf="password.invalid && password.touched" class="text-danger">
                    Password is required (min 6 characters and max 15 characters).
                  </div>
                </div>

                <!-- Confirm Password -->
                <div class="col-lg-4 col-md-4 mb-2" *ngIf="!editMode">
                  <label class="form-label m-0"> Confirm Password<span class="text-danger">*</span></label>
                  <input type="password" id="confirmPassword" name="confirmPassword" class="form-control"
                    [(ngModel)]="newMember.confirmPassword" placeholder="Enter Confirm Password"
                    #confirmPassword="ngModel" required minlength="6" maxlength="15"
                    [ngClass]="{'invalid-input': confirmPassword.invalid && confirmPassword.touched || (newMember.password !== newMember.confirmPassword && confirmPassword.touched)}" />

                  <div *ngIf="confirmPassword.invalid && confirmPassword.touched" class="text-danger">
                    Confirm Password is required.
                  </div>

                  <div *ngIf="newMember.password !== newMember.confirmPassword && confirmPassword.touched"
                    class="text-danger">
                    Passwords do not match.
                  </div>
                </div>

                <!-- Submit and Close Buttons -->
                <div class="modal-footer">
                  <button type="submit" class="btn btn-primary" [disabled]="memberForm.invalid">
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header d-flex justify-content-between align-items-center mb-0">
          <div class="row w-100">
            <div class="col-7">
              <h6 class="bold">Member List</h6>
            </div>
            <div class="col-5 d-flex gap-2">

              <select class="form-control" [formControl]="filterControl" (change)="onStatusChange($event)">
                <option value="">Select Member</option>
                <option value="true">Active</option>
                <option value="false">InActive</option>
                <option value="">All</option>
              </select>

              <input type="text" class="form-control" placeholder="Search member..." [formControl]="filterControl">

            </div>
          </div>
        </div>

        <div class="card-body">
          <div class="col-lg-12 mb-2">
            <!-- Search Input -->
            <!--<h4>Member List</h4>
            <div class="d-flex justify-content-end mb-2">
               <input type="text" [(ngModel)]="searchMemberText" (input)="filterMemberTable()" class="form-control w-25"
                        placeholder="Search Member..." /> 
            </div>-->


            <ngx-datatable class="ngx-datatable billdata colored-header sm table-striped table-hover" [rows]="rows"
              [columns]="columns" [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50" rowHeight="auto"
              [externalPaging]="true" [count]="page.totalRecords" [offset]="page.pageNumber" [limit]="page.pageSize"
              (page)="bindMemberDetail($event)" [virtualization]="false" [scrollbarV]="false" [scrollbarH]="true"
              [loadingIndicator]="loading">

              <!-- Serial Number Column -->
              <ngx-datatable-column name="#" [sortable]="false">
                <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                  <span>
                    {{ (page.pageNumber * page.pageSize) + rowIndex + 1 }}
                  </span>
                </ng-template>
              </ngx-datatable-column>

              <!-- Dynamic Data Columns -->
              <ngx-datatable-column *ngFor="let column of columns" [name]="column.name" [prop]="column.prop"
                [sortable]="true">
                <ng-template ngx-datatable-cell-template let-value="value">
                  {{ value }}
                </ng-template>
              </ngx-datatable-column>

              <!-- Action Column -->
              <ngx-datatable-column name="Action" [sortable]="false">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <div class="d-flex align-items-center gap-2">

                    <a class="edit btn btn-info btn-sm" href="javascript:void(0);" (click)="editMember(row)">
                      <i class="bi bi-pencil-square"></i>
                    </a>
                    <button class="btn btn-sm ms-1" [title]="row.isActive  ? 'Deactivate' : 'Activate'"
                      [ngClass]="row.isActive ? 'btn-success' : 'btn-danger'" (click)="toggleUserStatus(row)">
                      <i class="bi" [ngClass]="row.isActive ? 'bi-person-check' : 'bi-person-dash'"></i>
                    </button>
                  </div>

                </ng-template>
              </ngx-datatable-column>


            </ngx-datatable>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>